import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { colorsTheme } from 'resources/theme/styled/colors';
import { useEntityIntakeFormContext } from '../../EntityIntakeFormContext';

// components
import HelpAndWithdrawSection from '../HelpAndWithdrawSection';
import { Trans } from 'react-i18next';
import { Button, Col, Divider, Row, SectionIntro, Text } from '@ui';

const Returned = () => {
  const { t } = useTranslation('onboarding');
  const { reviewComments, intakeForm } = useEntityIntakeFormContext();

  return (
    <>
      <SectionIntro
        hideDivider
        titleColor={colorsTheme.colorWhite}
        title={t('intake_form.returned.title')}
      />
      <StyledRow justify="space-between">
        <Col span={24}>
          <TextWithTopMargin>
            {t('intake_form.returned.description')}
          </TextWithTopMargin>
          {intakeForm?.review?.summary ? (
            <TextWithTopMargin>
              <Text variant="h5" color={colorsTheme.colorWhite}>
                {t('intake_form.returned.summary_comments')}
              </Text>
              {intakeForm?.review?.summary}
            </TextWithTopMargin>
          ) : null}
          <StyledButton size="large" onClick={reviewComments}>
            {t('intake_form.returned.review_comments_button')}
          </StyledButton>
        </Col>
        <Col span={24}>
          <Divider />
          <HelpAndWithdrawSection
            helpTitle={t('intake_form.returned.need_help_title')}
            helpDescription={
              <Trans
                t={t}
                i18nKey="intake_form.returned.need_help_description"
                components={[
                  <Text
                    weight="semi-bold"
                    variant="span"
                    color={colorsTheme.colorWhite}
                  />,
                ]}
              />
            }
          />
        </Col>
      </StyledRow>
    </>
  );
};

const TextWithTopMargin = styled(Text)`
  margin-top: ${({ theme }) => theme.marginMd};
`;

const StyledRow = styled(Row)`
  height: 100%;
`;

const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.marginMd};
`;

export default Returned;
